// components/Footer/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    // Ссылки для продукции
    const productsLinks = [
        { name: 'Проволока', path: '/produktsiya/wire' },
        { name: 'Лента', path: '/produktsiya/tape' },
        { name: 'Пруток', path: '/produktsiya/rod' }
    ];

    // Ссылки для сплавов
    const alloysLinks = [
        { name: 'С высоким электросопротивлением', path: '/splavi/high-resistance' },
        { name: 'Стали и сплавы для сварки', path: '/splavi/welding-materials' },
        { name: 'Прецизионные магнитно-мягкие', path: '/splavi/soft-magnetic' },
        { name: 'Магнитно-мягкие с высокой магнитной индукцией', path: '/splavi/high-induction' },
        { name: 'Прецизионные магнитотвердые', path: '/splavi/hard-magnetic' },
        { name: 'Для упругих элементов', path: '/splavi/elastic' },
        { name: 'С заданным ТКЛР', path: '/splavi/tclr' },
        { name: 'Жаропрочные сплавы', path: '/splavi/heat-resistant-alloys' },
        { name: 'Стали специальные коррозионностойкие', path: '/splavi/corrosion-resistant' }
    ];

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Колонка 1 - Продукция */}
                <div className="footer-column">
                    <h3 className="footer-title">Продукция</h3>
                    <ul className="footer-links">
                        {productsLinks.map((link, index) => (
                            <li key={index}>
                                <Link to={link.path} className="footer-link">
                                    {link.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Колонка 2 - Сплавы */}
                <div className="footer-column">
                    <h3 className="footer-title">Сплавы</h3>
                    <ul className="footer-links alloys-list">
                        {alloysLinks.map((link, index) => (
                            <li key={index}>
                                <Link to={link.path} className="footer-link">
                                    {link.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Колонка 3 - Контакты */}
                <div className="footer-column">
                    <h3 className="footer-title">Контакты</h3>
                    <ul className="footer-links">
                        <li>
                            <a href="tel:+74996820168" className="footer-link">
                                <span className="footer-icon">📞</span>
                                +7 (499) 682-01-68
                            </a>
                        </li>
                        <li>
                            <a href="mailto:escaline.msk@gmail.com" className="footer-link">
                                <span className="footer-icon">✉️</span>
                                escaline.msk@gmail.com
                            </a>
                        </li>
                        <li>
                            <div className="footer-address">
                                <span className="footer-icon">📍</span>
                                <span>Офис: <br/>Москва, Россия<br />ул. Бутлерова, д. 17Б, помещ. 60/11/2</span>
                            </div>
                        </li>
                         <li>
                            <div className="footer-address">
                                <span className="footer-icon">🗄️</span>
                                <span>Склад: <br/>Москва, Россия<br />Новомосковский административный округ, район Коммунарка, деревня Николо-Хованское, 9/1А</span>
                            </div>
                        </li>
                        <li>
                            <Link to="/contacts" className="footer-link footer-contact-link">
                                <span className="footer-icon">🗺️</span>
                                Страница контактов →
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Нижняя строка с копирайтом */}
            <div className="footer-bottom">
                <div className="footer-bottom-container">
                    <p>&copy; {new Date().getFullYear()} Эскалайн. Все права защищены.</p>
                    <p>Поставка прецизионных сплавов</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;